import React from 'react';
import PropTypes from 'prop-types';

import { useReviewContext } from '@hydra/common/context';
import { CriteriumSkeleton } from '@hydra/common/criterium';

export const CriteriumText = ({ firstLine, secondLine }) => {
  const { variant } = useReviewContext();
  return (
    <>
      <p>{variant === 'nocrit' ? <CriteriumSkeleton width='30%' /> : firstLine}</p>
      <p>{variant === 'nocrit' ? <CriteriumSkeleton width='50%' /> : secondLine}</p>
    </>
  );
};

CriteriumText.propTypes = {
  firstLine: PropTypes.node.isRequired,
  secondLine: PropTypes.node
};

export default CriteriumText;
